export default __webpack_public_path__ + "static/media/Error_404.3743a5e9.png";